/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import ProductRow from "../ProductRow";
import ProductContext from "../../context/product/productContext";
import { HeaderRow, StyledHeader, StyledContainer } from "./Cart.styles";

const Cart = () => {
  const { loadCart, loadProducts, cartProducts } = useContext(ProductContext);

  useEffect(() => {
    const init = async () => {
      await loadProducts();

      loadCart(); //load cart {cart is seperate from entire products list }
    };

    init();
  }, []);

  //to use table or divs ??
  return (
    <StyledContainer>
      <StyledHeader>
        <HeaderRow>Product</HeaderRow>
        <HeaderRow>Price</HeaderRow>
        <HeaderRow>Quantity</HeaderRow>
        <HeaderRow>Total</HeaderRow>
      </StyledHeader>
      <>
        {cartProducts?.map(product => (
          <ProductRow {...product} key={product.id} />
        ))}
      </>
    </StyledContainer>
  );
};

export default Cart;
